import React from 'react';
import { MapPin, Clock, MessageCircle, Mail } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

export const Contact = () => {
  return (
    <section id="contacto" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            Contáctanos
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            ¿Necesitas ayuda con tu electrodoméstico? Estamos aquí para ayudarte
          </p>
        </div>

        {/* Contact Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          <Card className="border-2 border-blue-100 hover:border-blue-300 transition-all hover:shadow-xl group">
            <CardContent className="p-8 text-center">
              <div className="bg-blue-600 group-hover:bg-blue-700 p-4 rounded-full inline-block mb-4 transition-colors">
                <Mail className="w-8 h-8 text-white" />
              </div>
              <h3 className="font-bold text-blue-900 mb-3 text-lg">Email</h3>
              <a 
                href={`mailto:${companyInfo.email}`}
                className="text-gray-700 hover:text-blue-700 font-semibold mb-2 break-all text-sm transition-colors"
              >
                {companyInfo.email}
              </a>
            </CardContent>
          </Card>

          <Card className="border-2 border-blue-100 hover:border-blue-300 transition-all hover:shadow-xl group">
            <CardContent className="p-8 text-center">
              <div className="bg-blue-600 group-hover:bg-blue-700 p-4 rounded-full inline-block mb-4 transition-colors">
                <MapPin className="w-8 h-8 text-white" />
              </div>
              <h3 className="font-bold text-blue-900 mb-3 text-lg">Ubicación</h3>
              <p className="text-gray-700 font-semibold mb-2">{companyInfo.address}</p>
            </CardContent>
          </Card>

          <Card className="border-2 border-blue-100 hover:border-blue-300 transition-all hover:shadow-xl group">
            <CardContent className="p-8 text-center">
              <div className="bg-blue-600 group-hover:bg-blue-700 p-4 rounded-full inline-block mb-4 transition-colors">
                <Clock className="w-8 h-8 text-white" />
              </div>
              <h3 className="font-bold text-blue-900 mb-3 text-lg">Horario</h3>
              <p className="text-gray-700 font-semibold mb-2">{companyInfo.hours}</p>
            </CardContent>
          </Card>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16 max-w-2xl mx-auto">
          <div className="bg-blue-900 rounded-2xl p-10 text-white shadow-2xl">
            <h3 className="text-3xl font-bold mb-4">
              ¿Listo para reparar tu electrodoméstico?
            </h3>
            <p className="text-blue-100 text-lg mb-6">
              Contáctanos y uno de nuestros técnicos certificados te atenderá de inmediato
            </p>
            <Button 
              size="lg"
              className="bg-green-500 hover:bg-green-600 text-white text-lg px-10 py-6 font-bold shadow-xl"
              onClick={() => window.open(`https://wa.me/${companyInfo.whatsapp}?text=${encodeURIComponent('Hola, necesito información sobre sus servicios técnicos.')}`, '_blank')}
            >
              <MessageCircle className="w-6 h-6 mr-2" />
              Contactar por WhatsApp
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
